<script lang="ts">
  import { fly, fade } from 'svelte/transition';
  import Pregunta from './Pregunta.svelte';
  import { META } from '@/lib/contenido/meta';

  interface Props {
    abierta: boolean;
    frases: readonly string[];
    urlFoto: string;
  }

  let { abierta, frases, urlFoto }: Props = $props();

  let indiceFrase: number = $state(-1);
  let fotoCargada: boolean = $state(false);
  let fotoError: boolean = $state(false);

  /** Revela las frases secuencialmente cada 800ms. */
  $effect(() => {
    if (abierta && indiceFrase < frases.length - 1) {
      const id = setTimeout(() => {
        indiceFrase = indiceFrase + 1;
      }, 800);
      return () => clearTimeout(id);
    }
  });

  /** Carga la foto. */
  $effect(() => {
    if (!abierta || fotoCargada || fotoError) return;

    const img = new Image();
    img.src = urlFoto;
    img.onload = () => {
      fotoCargada = true;
    };
    img.onerror = () => {
      console.warn('[Carta] No se pudo cargar la foto');
      fotoError = true;
    };
  });
</script>

{#if abierta}
  <div class="carta" in:fly={{ y: 100, duration: 1200, easing: (t) => 1 - Math.pow(1 - t, 3) }}>
    <header class="encabezado">
      <h2 class="titulo-carta">{META.titulo}</h2>
      <p class="subtitulo-carta">{META.subtitulo}</p>
    </header>

    {#if fotoCargada}
      <figure class="polaroid" in:fade={{ duration: 600, delay: 400 }}>
        <img src={urlFoto} alt="" />
      </figure>
    {/if}

    <div class="frases">
      {#each frases as frase, i}
        {#if i <= indiceFrase}
          <p class="frase" in:fly={{ y: 20, duration: 600 }}>{frase}</p>
        {/if}
      {/each}
    </div>

    <footer class="pie">
      {#if indiceFrase >= frases.length - 1}
        <p class="firma" in:fade={{ duration: 800, delay: 200 }}>{META.firma}</p>
        <Pregunta />
      {/if}
    </footer>
  </div>
{/if}

<style>
  .carta {
    position: fixed;
    inset: 0;
    z-index: 50;
    background: var(--color-cielo-papel);
    color: var(--color-texto-carta);
    overflow-y: auto;
    padding: var(--espaciado-xl);
    max-width: 640px;
    margin: 0 auto;
    line-height: 1.7;
  }

  .encabezado {
    text-align: center;
    margin-bottom: var(--espacado-l);
  }

  .titulo-carta {
    font-size: 1.75rem;
    color: var(--color-texto-carta);
    margin-bottom: var(--espaciado-xs);
  }

  .subtitulo-carta {
    font-style: italic;
    color: rgba(43, 36, 24, 0.6);
    font-size: 1rem;
  }

  .polaroid {
    margin: var(--espaciado-l) auto;
    max-width: 280px;
    padding: 12px 12px 32px;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transform: rotate(-2deg);
  }

  .polaroid img {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: cover;
  }

  .frases {
    margin-top: var(--espacado-l);
  }

  .frase {
    margin-bottom: var(--espacado-m);
    font-size: 1.05rem;
    line-height: 1.7;
  }

  .pie {
    margin-top: var(--espacado-xl);
    text-align: right;
  }

  .firma {
    font-style: italic;
    color: rgba(43, 36, 24, 0.7);
    margin-bottom: var(--espacado-l);
  }

  @media (max-width: 480px) {
    .carta {
      padding: var(--espaciado-l) var(--espaciado-m);
    }
    .titulo-carta {
      font-size: 1.5rem;
    }
    .frase {
      font-size: 1rem;
    }
  }
</style>
